export default class SyncForeignItemsRequest {
  constructor(
    public siteId: number,
    public foreignItems: SyncForeignItemRequest[]) {
  }
}

export class SyncForeignItemRequest {
  constructor(
    public itemId: number,
    public code: string,
    public trackStock: boolean) {
  }
}
